import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import TelevisionTab from "../views/tv.js";
import RadioTab from "../views/radio.js";

import "../App.css";

class Main extends Component {
  render() {
    return (
      <Switch>
        <Route path="/" exact>
          <Redirect to="/television" />
        </Route>
        <Route path="/television" component={TelevisionTab} />
        <Route path="/radio" component={RadioTab} />
        <Route path="*">
          <Redirect to="/" />
        </Route>
      </Switch>
    );
  }
}

export default Main;
